import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { aOrAn } from 'helpers/HelperFunctions';
import styles from './ProjectUpsell.module.scss';

const FALLBACK_ROLES_BY_MEDIA = {
  audio: ['vocalist', 'dj', 'musicproducer', 'musician'],
  video: ['filmproducer', 'videoeditor', 'cameraoperator', 'postproduction'],
  default: ['graphicdesigner', 'illustrator', 'imageeditor', 'uxdesigner'],
};

const matchesTag = (item, tag) =>
  item.slug.replace(/-/g, '') === tag ||
  item.slug_plural.replace(/-/g, '') === tag;

const findByTag = (items, tag) =>
  (items || []).find(
    (item) => typeof item !== 'undefined' && matchesTag(item, tag)
  );

const getTalentLinks = (project, suggestedRoles, suggestedSkills) => {
  if (!project) {
    return { roles: [], skills: [] };
  }

  const tags = project.tags || [];
  const roles = [];
  const skills = [];
  const seenRoles = new Set();
  const seenSkills = new Set();

  tags.forEach((tag) => {
    const role = findByTag(suggestedRoles, tag);
    if (role && !seenRoles.has(role.slug_plural)) {
      seenRoles.add(role.slug_plural);
      roles.push(role);
    }

    const skill = findByTag(suggestedSkills, tag);
    if (skill && !seenSkills.has(skill.slug_plural)) {
      seenSkills.add(skill.slug_plural);
      skills.push(skill);
    }
  });

  if (roles.length > 0 || skills.length > 0) {
    return { roles, skills };
  }

  if (!suggestedRoles || suggestedRoles.length === 0) {
    return { roles: [], skills: [] };
  }

  const fallbackTags =
    FALLBACK_ROLES_BY_MEDIA[project.mediaType] ||
    FALLBACK_ROLES_BY_MEDIA.default;

  for (let i = 0; i < fallbackTags.length; i++) {
    const role = findByTag(suggestedRoles, fallbackTags[i]);
    if (role) {
      return { roles: [role], skills: [] };
    }
  }

  return { roles: [], skills: [] };
};

const ProjectBuyerUpsell = ({ project, suggestedRoles, suggestedSkills }) => {
  const { roles, skills } = getTalentLinks(
    project,
    suggestedRoles,
    suggestedSkills
  );

  if (roles.length === 0 && skills.length === 0) {
    return null;
  }

  return (
    <div className={styles.buyerUpsellContainer}>
      <p className={styles.buyerUpsellTitle}>
        <Link to="/hire-a-freelancer">Get quality freelance talent</Link>
      </p>
      <ul>
        {roles.map((role) => (
          <li key={role.slug_plural}>
            <a
              className={styles.buyerUpsellItem}
              href={`/find/${role.slug_plural}`}
            >
              Hire {aOrAn(role.name)} {role.name}
            </a>
          </li>
        ))}
        {skills.map((skill) => (
          <li key={skill.slug_plural}>
            <Link
              className={styles.buyerUpsellItem}
              to={`/get/${skill.slug_plural}`}
            >
              Get your {skill.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

ProjectBuyerUpsell.propTypes = {
  project: PropTypes.object,
  suggestedRoles: PropTypes.array,
  suggestedSkills: PropTypes.array,
};

export default ProjectBuyerUpsell;
